import emptyStateClientListSvg from './../../../assets/empty-states/client_list.svg';
import emptyStateClientRequestSvg from './../../../assets/empty-states/client_request.svg';
import emptyStateDealsSvg from './../../../assets/empty-states/deals.svg';
import emptyStateEmailEmptySvg from './../../../assets/empty-states/email-empty.svg';
import emptyStateEmailsSvg from './../../../assets/empty-states/emails.svg';
import emptyStateInvoiceSvg from './../../../assets/empty-states/invoice.svg';
import emptyStateNoMatchingResultFoundSvg from './../../../assets/empty-states/no_match_result_found.svg';
import emptyStateNoMatchingResultFoundMiniSvg from './../../../assets/empty-states/no_match_result_mini_found.svg';
import emptyStateNoNotificationFoundSmallSvg from './../../../assets/empty-states/no_notification_found.svg';
import emptyStateNoResultFoundSvg from './../../../assets/empty-states/no_result_found.svg';
import emptyStatePaymentSetup from './../../../assets/empty-states/payment_setup.svg';
import emptyStatePaymentSetupComplete from './../../../assets/empty-states/payment_setup_complete.svg';
import emptyStateProjectsSvg from './../../../assets/empty-states/projects.svg';
import emptyStateProposalSvg from './../../../assets/empty-states/proposal.svg';
import emptyStateRemindersSvg from './../../../assets/empty-states/reminders.svg';
import emptyStateServicesSvg from './../../../assets/empty-states/services.svg';
import emptyStateSettingPeopleSvg from './../../../assets/empty-states/setting_people.svg';
import emptyStateTasksSvg from './../../../assets/empty-states/tasks.svg';
import emptyStateTaxRatesSvg from './../../../assets/empty-states/tax_rates.svg';
import emptyStateTemplatesSvg from './../../../assets/empty-states/templates.svg';
import emptyStateTimeSvg from './../../../assets/empty-states/time.svg';
import emptyStateTimeSmallSvg from './../../../assets/empty-states/time_small.svg';

export enum EmptyStateIllustrationType {
  Templates = 'templates',
  NoResultFound = 'no_result_found',
  NoMatchingResultFound = 'no_matching_result_found',
  NoMatchingResultFoundSmall = 'no_match_result_found_small',
  NoNotificationFound = 'no_notification_found',
  Time = 'Time',
  TimeSmall = 'time_small',
  ClientList = 'client_list',
  Proposal = 'proposal',
  Services = 'services',
  SettingPeople = 'setting_people',
  TaxRates = 'tax_rates',
  PaymentSetup = 'payment_setup',
  PaymentSetupComplete = 'payment_setup_complete',
  Projects = 'projects',
  Tasks = 'tasks',
  Deals = 'deals',
  Emails = 'emails',
  Invoice = 'invoice',
  ClientRequest = 'client_request',
  Reminders = 'reminders',
  EmailEmpty = 'email_empty',
}

export const EmptyStateIllustrationSvgMap: { [key: string]: string } = {
  [EmptyStateIllustrationType.Templates]: emptyStateTemplatesSvg,
  [EmptyStateIllustrationType.NoResultFound]: emptyStateNoResultFoundSvg,
  [EmptyStateIllustrationType.NoMatchingResultFound]:
    emptyStateNoMatchingResultFoundSvg,
  [EmptyStateIllustrationType.NoMatchingResultFoundSmall]:
    emptyStateNoMatchingResultFoundMiniSvg,
  [EmptyStateIllustrationType.NoNotificationFound]:
    emptyStateNoNotificationFoundSmallSvg,
  [EmptyStateIllustrationType.ClientList]: emptyStateClientListSvg,
  [EmptyStateIllustrationType.Proposal]: emptyStateProposalSvg,
  [EmptyStateIllustrationType.Services]: emptyStateServicesSvg,
  [EmptyStateIllustrationType.SettingPeople]: emptyStateSettingPeopleSvg,
  [EmptyStateIllustrationType.TaxRates]: emptyStateTaxRatesSvg,
  [EmptyStateIllustrationType.PaymentSetup]: emptyStatePaymentSetup,
  [EmptyStateIllustrationType.PaymentSetupComplete]:
    emptyStatePaymentSetupComplete,
  [EmptyStateIllustrationType.Projects]: emptyStateProjectsSvg,
  [EmptyStateIllustrationType.Tasks]: emptyStateTasksSvg,
  [EmptyStateIllustrationType.Deals]: emptyStateDealsSvg,
  [EmptyStateIllustrationType.Emails]: emptyStateEmailsSvg,
  [EmptyStateIllustrationType.TimeSmall]: emptyStateTimeSmallSvg,
  [EmptyStateIllustrationType.Time]: emptyStateTimeSvg,
  [EmptyStateIllustrationType.Invoice]: emptyStateInvoiceSvg,
  [EmptyStateIllustrationType.ClientRequest]: emptyStateClientRequestSvg,
  [EmptyStateIllustrationType.Reminders]: emptyStateRemindersSvg,
  [EmptyStateIllustrationType.EmailEmpty]: emptyStateEmailEmptySvg,
};
